export const LEVEL_BONUS = 50; // keep in sync with backend/levels.py
export const LEVELS = [
  { min: 0, name: "Neuling", emoji: "🌱", color: "from-slate-400 to-slate-500" },
  { min: 50, name: "Fan", emoji: "💗", color: "from-pink-400 to-rose-500" },
  { min: 150, name: "Superfan", emoji: "⭐", color: "from-amber-400 to-orange-500" },
  { min: 300, name: "Insider", emoji: "🔥", color: "from-orange-500 to-rose-500" },
  { min: 600, name: "Herzensmensch", emoji: "💖", color: "from-rose-500 to-fuchsia-500" },
  { min: 1000, name: "Community-Star", emoji: "🌟", color: "from-fuchsia-500 to-violet-500" },
  { min: 1800, name: "Legende", emoji: "👑", color: "from-amber-400 to-yellow-500" },
  { min: 3000, name: "itzPlay-Ikone", emoji: "💎", color: "from-cyan-400 to-fuchsia-500" },
];

export function levelFor(points = 0) {
  let i = 0;
  while (i + 1 < LEVELS.length && points >= LEVELS[i + 1].min) i++;
  const next = LEVELS[i + 1];
  const cur = LEVELS[i];
  return { ...cur, level: i + 1, next, progress: next ? Math.min(1, (points - cur.min) / (next.min - cur.min)) : 1, missing: next ? next.min - points : 0 };
}
